import React from "react";
import PropTypes from "prop-types";

import HeaderLink from "./HeaderLink";

import styles from "./HeaderLinkGroup.css";

export default function HeaderLinkGroup(props) {
  return (
    <div className={`${styles.root} ${props.className || ""}`}>
      {props.links.map(link => (
        <HeaderLink key={link.to} {...link} />
      ))}
    </div>
  );
}

HeaderLinkGroup.propTypes = {
  links: PropTypes.array.isRequired,
  className: PropTypes.string,
};
